module.exports = __webpack_public_path__ + "img/inception-hcms-green.7e05efaf.png";